import { defineAsyncComponent } from 'vue'

const Route = defineAsyncComponent(() => import('./route.vue'))

export { Route }
